import Header from './components/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/homePage/HomePage';
import CareersPage from './pages/careersPage/CareersPage';
import ContactPage from './pages/contactPage/ContactPage';
import InvestPage from './pages/investPage/InvestPage';
import ProductServices from './pages/productServices/ProductServices';
import SAMProductImage from "./assets/images/SAM-indoor-avg.png"
import AgTronProductImage from "./assets/images/AgTron-workhouse.png"
import AgTronProductImage2 from "./assets/images/AgTronDescriptionImage.png"
import FooterCTA from './components/FooterCTA';
import Footer from './components/Footer';
import AboutPage from './pages/aboutPage/AboutPage';
import AgTronGrowImage from "./assets/images/AgTronGrowImage.png";
import TradingPlatformImage from "./assets/images/trading-platform.png";
import TradingPlafromUseCaseImage from "./assets/images/trading-platform-use-case.png";
import JBSLogo from "./assets/logo.png";
import AgroLogo from "./assets/agroLogo.png";
import AICVWebDevImage from "./assets/images/ai-cv-webdev.png";


function App() {
  return (
    <BrowserRouter>
      <div className="p-0">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about&portfolio" element={<AboutPage />} />
          <Route path="/products&services/SAM-Robot" element={<ProductServices topText="Our Products & Services" mainHeadingParts={[
            { text: 'SAM' },
            { text: 'Indoor', highlight: true },
            { text: 'AVG' },
            { text: 'Robot', highlight: true },
          ]} subText="From indoor robotics to smart agriculture and trading platforms, our
offerings enable scalable innovation." heroImage={SAMProductImage} button1Type="price" button1Text="£150 / 15,000 " button1Link="/products&services"
            button1TextDescription="(with Raspberry Pi & Software)" button2Type="enquiry" button2Link="/contact" keySpecs={true}
            specs={[
              {
                icon: "package", // you can use "box", "cube", or similar based on your icon library
                title: "Payload",
                description: "Carries up to 20 kg of tools, sensors, or cargo, allowing multi-purpose field deployment."
              },
              {
                icon: "ruler", // or "maximize", "resize", etc.
                title: "Dimensions",
                description: "Measures 1.2m x 0.8m x 0.6m, designed for optimal stability and low profile operation in diverse terrains."
              },
              {
                icon: "batteryCharging", // or "battery", depending on the icon set
                title: "Battery Life",
                description: "Runs continuously for up to 8 hours on a full charge, with optional solar panel extension."
              },
              {
                icon: "gauge", // or "speedometer"
                title: "Top Speed",
                description: "Achieves a maximum speed of 12 km/h for rapid field coverage when needed."
              },
              {
                icon: "radar", // or "activity", "scan", "signal"
                title: "Sensor Kit",
                description: "Equipped with LiDAR, HD camera, thermal imaging, and soil sensors for real-time data acquisition."
              },
              {
                icon: "code", // or "terminal", "layers"
                title: "Software Support",
                description: "Supports ROS 2, Python SDK, and cloud integration for autonomous mission planning and telemetry."
              }
            ]}

            productImages={[SAMProductImage, SAMProductImage, SAMProductImage, SAMProductImage]}
            CTAHeading={"“Want a fleet of SAMs or a custom unit? Contact us today.”"}
          />} />
            <Route path="/products&services/AgTron-Workhorse" element={<ProductServices topText="Our Products & Services" mainHeadingParts={[
            { text: 'AgTron' },
            { text: 'Workhorse', highlight: true },
            { text: 'Electric' },
            { text: 'Rover', highlight: true },
          ]} subText="Smart Outdoor Rovers for Modern Farming & Beyond" heroImage={AgTronProductImage} button1Type="price" button1Text="£900" button1Link="/products&services"
             button2Type="enquiry" button2Link="/contact" keySpecs={true}
             variants =  {[
              {
                icon: "flask", // you can replace with an appropriate icon name
                title: "Research Platform",
                description: "Versatile experimental base designed for adaptable research applications across diverse terrains and data-gathering missions."
              },
              {
                icon: "bolt", // represents electricity or power
                title: "AI Electric Micro Tractor",
                description: "Autonomous electric tractor equipped with AI-driven navigation, ideal for precision farming and energy-efficient operations."
              },
              {
                icon: "wifi", // represents connectivity or remote access
                title: "Web-connected Remote Operable Rover",
                description: "Remotely accessible rover with real-time telemetry and control, perfect for surveillance, data acquisition, and remote inspection tasks."
              }
            ]}
             specs = {[
              {
                icon: "ruler", // could be "maximize", "expand", etc. depending on icon set
                title: "Dimensions",
                description: "Compact 2.5m x 1.5m x 2m footprint optimized for modular deployment in urban or rural settings."
              },
              {
                icon: "settings", // or "cpu", "robot", "repeat"
                title: "Automation",
                description: "Integrated automation for irrigation, environmental sensors, and climate control with adaptive scheduling."
              },
              {
                icon: "monitor", // or "terminal", "settings-2"
                title: "Remote Access Panel",
                description: "Secure web-based dashboard for live telemetry, manual overrides, and system diagnostics."
              },
              {
                icon: "smartphone", // or "globe", "app-window"
                title: "Mobile/Web App",
                description: "User-friendly mobile and web apps with real-time control, historical data logs, and live video feeds."
              }
            ]}
            

            productImages={[AgTronProductImage, AgTronProductImage, AgTronProductImage, AgTronProductImage]}
            CTAHeading={"“Explore Web3 Farming Experience Agrotronic Farms Ltd”"}
            section2HeadingParts={[
              { text: 'Transforming' },
              { text: 'Industries ', highlight: true },
              { lineBreak: true },
              { text: ' Through' },
              { text: 'Innovation', highlight: true },
            ]}
            section2Image={AgTronProductImage2}
            />
        } />
                    <Route path="/products&services/AgTronGrow" element={<ProductServices topText="Our Products & Services" mainHeadingParts={[
            { text: 'AgTronGrow', highlight: true  },
            { text: ' - Smart Greenhouse'},
            { lineBreak: true },
            { text: 'System', highlight: true },
          ]} subText="Grow from Anywhere. Monitor. Water. Control" heroImage={AgTronGrowImage} button1Type="price" button1Text="£900" button1Link="/products&services"
             button2Type="visit" button2Link="/contact" keySpecs={true}
    
             specs = {[
              {
                icon: "ruler", // could be "maximize", "expand", etc. depending on icon set
                title: "Dimensions",
                description: "Compact 2.5m x 1.5m x 2m footprint optimized for modular deployment in urban or rural settings."
              },
              {
                icon: "settings", // or "cpu", "robot", "repeat"
                title: "Automation",
                description: "Integrated automation for irrigation, environmental sensors, and climate control with adaptive scheduling."
              },
              {
                icon: "monitor", // or "terminal", "settings-2"
                title: "Remote Access Panel",
                description: "Secure web-based dashboard for live telemetry, manual overrides, and system diagnostics."
              },
              {
                icon: "smartphone", // or "globe", "app-window"
                title: "Mobile/Web App",
                description: "User-friendly mobile and web apps with real-time control, historical data logs, and live video feeds."
              }
            ]}
            

            productImages={[AgTronGrowImage, AgTronGrowImage, AgTronGrowImage, AgTronGrowImage]}
            CTAHeading={"“Explore Web3 Farming Experience Agrotronic Farms Ltd”"}
            section2HeadingParts={[
              { text: '" Scale up for ' },
              { text: 'multi-acre ', highlight: true },
              { lineBreak: true },
              { text: ' greenhouses. Available for' },
              { lineBreak: true },
              { text: 'farms ', highlight: true },
              { text: 'and' },
              { text: ' institutions. "', highlight: true },
            ]}
        
            />
        } />
          <Route path="/products&services/Trading-Platforms" element={<ProductServices topText="Our Products & Services" mainHeadingParts={[
            { text: 'Advanced', highlight: true  },
            { text: '  Algorithmic '},
            { text: 'Trading', highlight: true },
            { lineBreak: true },
            { text: 'Platforms', highlight: true },
          
          ]} subText="Built on cTrader, OANDA & Solana. Licensed or Custom-Built." heroImage={TradingPlatformImage} button1Type="price" button1Text="£900" button1Link="/products&services"
             button2Type="enquiry" button2Link="/contact" keySpecs={true}
            type={"trading"}
            pricingPlans= {[
              {
                  title: "Basic Trader",
                  description: "For individuals starting their trading journey.",
                  price: "$49",
                  frequency: "/month",
                  features: ["Real-time Market Data", "Basic Charting Tools", "Email Support", "Up to 100 Trades/Month"],
                  ctaText: "Get Started",
                  featured: false
              },
              {
                  title: "Pro Trader",
                  description: "For experienced traders who need advanced tools.",
                  price: "$99",
                  frequency: "/month",
                  features: ["All Basic Features", "Advanced API Access", "Priority Support", "Unlimited Trades", "Strategy Backtesting"],
                  ctaText: "Choose Pro",
                  featured: true
              },
              {
                  title: "Institutional",
                  description: "For businesses and trading firms.",
                  price: "Custom",
                  frequency: "",
                  features: ["All Pro Features", "Dedicated Account Manager", "Custom Integrations", "On-site Training"],
                  ctaText: "Contact Sales",
                  featured: false
              }
          ]}
          trustedByLogos={[
            { src: JBSLogo, alt: "Forbes" },
            { src: AgroLogo, alt: "Nasdaq" },
            { src: JBSLogo, alt: "TechCrunch" },
            { src: AgroLogo, alt: "Bloomberg" },
            { src: JBSLogo, alt: "Investopedia" }
        ]}
        faqs={ [
          {
              question: "Can I change my plan later?",
              answer: "Absolutely! You can upgrade, downgrade, or cancel your plan at any time from your account dashboard. Changes will be prorated for the current billing cycle."
          },
          {
              question: "What payment methods do you accept?",
              answer: "We accept all major credit cards (Visa, MasterCard, American Express) as well as PayPal. For Institutional plans, we also support wire transfers."
          },
          {
              question: "Is there a free trial available?",
              answer: "Yes, we offer a 14-day free trial for our Pro Trader plan. No credit card is required to get started. You can explore all the features and see if it's the right fit for you."
          }
      ]}
             offers = {[
              {
                icon: "chartLine", // suitable for financial platforms
                title: "cTrader for FX & Indices",
                description: "Advanced trading platform offering deep liquidity, algorithmic trading, and intuitive UI for forex and index markets."
              },
              {
                icon: "api", // represents integration
                title: "OANDA API for Pro Trading",
                description: "Robust API access for professional-grade trading automation, real-time market data, and order execution with OANDA."
              },
              {
                icon: "layers", // represents blockchain or layers of tech
                title: "Solana + DeFi Frontends",
                description: "Fast, scalable blockchain infrastructure integrated with DeFi dashboards and DEX interfaces for decentralized asset management."
              }
            ]}
            

            productImages={[TradingPlatformImage, TradingPlatformImage, TradingPlatformImage, TradingPlatformImage]}
            CTAHeading={"“Explore Web3 Farming Experience Agrotronic Farms Ltd”"}
            section2HeadingParts={[
              { text: 'Use' },
              { text: ' Cases', highlight: true },
            
            ]}
            section2Image = {TradingPlafromUseCaseImage}
            />
        } />

<Route path="/products&services/AI-CV-WebDev" element={<ProductServices topText="Our Products & Services" mainHeadingParts={[
            { text: 'A.I, Computer', highlight: true  },
            { text: ' Vision & Web '},
            {lineBreak:true},
            { text: 'Solutions' },
          
          ]} subText="“From image recognition to enterprise dashboards.”" heroImage={AICVWebDevImage} button1Type="price" button1Text="$100 " button1Link="/products&services"
            button1TextDescription="" button2Type="enquiry" button2Link="/contact" keySpecs={true}
            specs={[
              {
                icon: "eye", // Represents vision tasks
                title: "AI Inference & Models",
                description: "End-to-end pipeline for object detection, classification, and fine-tuned models deployed across real-world computer vision projects."
              },
              {
                icon: "car", // Vehicle detection and analysis
                title: "Vehicle & Damage Detection",
                description: "Specialized models for vehicle recognition, road-damage classification, and agricultural insights using satellite or drone imagery."
              },
              {
                icon: "code", // Web development
                title: "Full-stack Web Development",
                description: "Robust web platforms built using MERN, Django, and custom APIs with dashboard interfaces tailored for AI-driven insights and control."
              }
            ]}

            productImages={[AICVWebDevImage,AICVWebDevImage,AICVWebDevImage,AICVWebDevImage]}
            CTAHeading={"“Looking to develop a smart platform or product?”"}
          />} />   <Route path="/services/consulting" element={<div>Consulting</div>} />
          <Route path="/services/support" element={<div>Support</div>} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/invest" element={<InvestPage />} />
        </Routes>
      </div>

      <div className='mt-12 -mb-24'>
        <FooterCTA />
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
